/**
 *
 *
 * @prettier
 * @author Brook Worku
 * @since
 *
 * The form fetchs FFPS user details based on UserName
 */
//@ts-check
import React, { useEffect } from 'react'
import { InjectedFormProps, Field, formValueSelector, reduxForm } from 'redux-form'
import LgyCheckbox from 'app/components/util/lgy-checkbox/LgyCheckbox'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import { maxLength, required } from 'app/utils/validations'
import { connect } from 'react-redux'
import { fetchFfpsUserInfo, resetFfpsUserDetailAction } from '../actions/ffpsUserDetailsActions'
import FfpsUserInfoTable from './FfpsUserInfoTable'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import { IConnectProps, IFormValues } from '../../settings/types/FfpsUserDetailsTypes'
const maxLength8 = maxLength(8)

const FfpsCheckBox = () => (
  <Field
    id='ffpsCheckbox'
    name='ffpsCheckbox'
    component={LgyCheckbox}
    label='FFPS Checkbox'
    aria-label='FFPS Link SecId Checkbox'
    tooltip="This links user's FFPS account credentials to your LGY Hub account. To link your LGY Hub account please enter FFPS username and click fetch, then click submit."
  />
)

const FfpsInputUser = () => (
  <Field
    id='ffpsUsername'
    name='ffpsUsername'
    component={LgyInputField}
    label='FFPS User Name'
    aria-label='FFPS User Name'
    tooltip="This is the user's FFPS username which will be linked to user's LGY Hub account"
    required={true}
    validate={[required, maxLength8]}
  />
)

const FetchFfpsUserDetails = ({
  vaEauthSecId,
  ffpsCheckbox,
  ffpsUsername,
  userDetailInfo,
  handleSubmit,
  fetchFfpsUserInfo,
  resetFfpsUserDetailAction,
  invalid
}: InjectedFormProps<IFormValues, IConnectProps> & IConnectProps) => {
  const onSubmit = ({ ffpsUsername }: IFormValues) => {
    fetchFfpsUserInfo(ffpsUsername, vaEauthSecId)
  }

  useEffect(() => {
    if (!ffpsCheckbox && !userDetailInfo.ffpsAffiliated) {
      resetFfpsUserDetailAction()
    }
  }, [ffpsCheckbox, resetFfpsUserDetailAction, userDetailInfo.ffpsAffiliated])

  return (
    <div>
      <FfpsCheckBox />
      {userDetailInfo.error && (
        <LgyAlertDialog
          type='error'
          text={userDetailInfo.errorMsg}
          id={undefined}
          heading={undefined}
          paragraph={undefined}
          children={undefined}
        />
      )}
      {ffpsCheckbox && userDetailInfo.ffpsAffiliated && userDetailInfo.ffpsUsername === ffpsUsername && (
        <FfpsInputUser />
      )}

      {ffpsCheckbox && (!userDetailInfo.ffpsAffiliated || userDetailInfo.ffpsUsername !== ffpsUsername) && (
        <div>
          <FfpsInputUser />
          <button
            className='usa-button'
            onClick={handleSubmit(onSubmit)}
            disabled={invalid}
            hidden={userDetailInfo.ffpsAffiliated && ffpsUsername === userDetailInfo.ffpsUsername}
          >
            Fetch
          </button>
          {(userDetailInfo.ffpsUserFirstName || userDetailInfo.ffpsUserFirstName || userDetailInfo.ffpsUserEmail) &&
            !userDetailInfo.error &&
            !userDetailInfo.ffpsAffiliated && (
              <FfpsUserInfoTable
                ffpsUserFirstName={userDetailInfo.ffpsUserFirstName}
                ffpsUserLastName={userDetailInfo.ffpsUserLastName}
                ffpsUserEmail={userDetailInfo.ffpsUserEmail}
                ffpsUsername={userDetailInfo.ffpsUsername}
                ffpsAffiliated={userDetailInfo.ffpsAffiliated}
                error={userDetailInfo.error}
                errorMsg={userDetailInfo.errorMsg}
              />
            )}
        </div>
      )}
    </div>
  )
}

const selector = formValueSelector('fetchFfpsUserDetails')

const mapStateToProps = (state: any) => ({
  ffpsCheckbox: selector(state, 'ffpsCheckbox'),
  ffpsUsername: selector(state, 'ffpsUsername'),
  userDetailInfo: state.ffpsUserDetail
})

const mapDispatchToProps = {
  fetchFfpsUserInfo,
  resetFfpsUserDetailAction
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm<IFormValues, IConnectProps>({
    form: 'fetchFfpsUserDetails',
    enableReinitialize: true,
    initialValues: {
      ffpsCheckbox: false
    }
  })(FetchFfpsUserDetails)
)
